import { pdfDetails } from './pdf_details.type';

const types = {
  ...pdfDetails,
};

export default types;
